import React from 'react';
import { observer } from 'mobx-react';
import CheckoutLinkFormService from '../services/CheckoutLinkFormService';
import CheckoutLinkProductsModal from './CheckoutLinkProductsModal';
import { toJS } from 'mobx';

class CheckoutLinkProductsFormContainer extends React.Component {
  render() {
    return (
      <CheckoutLinkProductsModal
        onChange={CheckoutLinkFormService.productForm.setValue}
        values={toJS(CheckoutLinkFormService.productForm.getValues())}
        onSubmit={CheckoutLinkFormService.handleSubmitProduct}
        errors={CheckoutLinkFormService.productForm.errors}
        onReset={CheckoutLinkFormService.handleCloseModal}
        isModalOpen={CheckoutLinkFormService.isModalOpen}
        onClose={CheckoutLinkFormService.handleCloseModal}
      />
    );
  }
}

export default observer(CheckoutLinkProductsFormContainer);
